import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/app.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'
//theming
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
const themes = {
    default: '/css/default.css',
    eek30: '/css/eek30.css',
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <I18nextProvider i18n={i18n}>
          <ThemeSwitcherProvider defaultTheme="default" themeMap={themes}>
              <App />
          </ThemeSwitcherProvider>
      </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
